<template>
  <div></div>
</template>

<script>
export default {
  name: 'MessageNotification',
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}

}
</script>
<style scoped>
</style>